import { queueEvent } from "./utils/analyticsClient";

export function routeFamily(path) {
  if (path === "/" || path === "/home") return "home";
  if (/^\/(cost-guides|costs|blog|trade-advice|reports)(\/|$)/.test(path)) return path.split("/")[1];
  if (/^\/chat(\/|$)/.test(path)) return "chat";
  if (/^\/project-summary(\/|$)/.test(path)) return "project-summary";
  if (/^\/(signup|signup-homeowner|signup-contractor)(\/|$)/.test(path)) return "signup";
  return "public-other";
}

// Each document owns its metrics, including its original landing route. A late
// callback must not be misattributed to a later SPA route.
let started = false;
let allowed = false;
export default async function reportWebVitals(enabled = false) {
  allowed = enabled;
  if (!enabled || started || /ReactSnap|bot|headless/i.test(navigator.userAgent)) return;
  started = true;
  const family = routeFamily(window.location.pathname);
  const device = window.matchMedia?.("(max-width: 767px)").matches ? "mobile" : "desktop";
  try {
    const { onCLS, onINP, onLCP } = await import("web-vitals");
    const report = ({ name, value, rating, id }) => {
      if (!allowed || !Number.isFinite(value)) return;
      // Exclude attribution entries, DOM selectors, full URLs and user text.
      queueEvent("web_vital", {
        metric_name: name, value, rating, metric_id: id,
        route_family: family, device_class: device,
        release: process.env.REACT_APP_VERSION || "development",
      }, `/${family}`);
    };
    onCLS(report); onINP(report); onLCP(report);
  } catch {
    started = false; // Measurement must never interrupt a customer journey.
  }
}
